import React, { ReactNode } from 'react';

import RadioButton from '@components/RadioButton/RadioButton';
import { Box, Text } from '@components/Restyle';

export interface TaskCardProps {
  title?: string;
  children?: ReactNode;
}

const TaskCard: React.FC<TaskCardProps> = ({ title = '', children }) => {
  return (
    <Box borderColor='grey02' borderWidth={1} flex={1} borderRadius='xs'>
      <Box
        borderTopLeftRadius='xs'
        borderTopRightRadius='xs'
        backgroundColor='greenSecondaryMild'
        flexDirection='row'
        justifyContent='space-between'>
        <Box flexDirection='row' margin='xxs'>
          <Box marginHorizontal='xxs'>
            <RadioButton iconVariant='m' onPress={() => {}} isSelected={true} />
          </Box>
          <Text
            textAlign='center'
            marginHorizontal='xxs'
            fontSize={13}
            color='greenSecondary'
            fontWeight='400'
            variant='metadata'>
            {title || ''}
          </Text>
        </Box>
      </Box>
      {children}
    </Box>
  );
};

export default TaskCard;
